import { useClientMembershipCampaign } from '@itarget/shared'
import { useContext, useEffect } from 'react'
import { FidelityContext } from '../../../context/FidelityContext'

export const useGroup = () => {
  const { data, fetchCollection, isLoaded } = useClientMembershipCampaign()
  const { getCurrentCampaignFilter, filterCampaignEnums } =
    useContext(FidelityContext)
  const currentCampaignFilter = getCurrentCampaignFilter()
  const campaignCollection = data?.data?.data || []

  // biome-ignore lint/correctness/useExhaustiveDependencies: <Código entra em loop se adicionar dependência do fetchCollection>
  useEffect(() => {
    const getCurrentKeyCollection = () => {
      const indexOfCurrentCollection = Object.values(
        filterCampaignEnums
      ).findIndex((value) => value === currentCampaignFilter)
      const keyOfCurrentCollection =
        Object.keys(filterCampaignEnums)[indexOfCurrentCollection]
      return keyOfCurrentCollection
    }
    const currentKeyCollection = getCurrentKeyCollection()
    fetchCollection(currentKeyCollection)
  }, [filterCampaignEnums, currentCampaignFilter])

  return { campaignCollection, isLoaded }
}
